export const SUBSCRIPTION_PLANS = [
  {
    role_id: 7,
    formule: "Presence Free",
    label: "Presence Free",
    priceLabel: "Gratuit",
    amount: null,
    product_id: null,
    tone: "emerald",
  },
  {
    role_id: 3,
    formule: "Presence",
    label: "Presence",
    priceLabel: "10 € / an",
    amount: 10,
    product_id: "prod_RihyvIWIUVQQp1",
    tone: "blue",
  },
  {
    role_id: 4,
    formule: "Presence Pro",
    label: "Presence Pro",
    priceLabel: "20 € / an",
    amount: 20,
    product_id: "prod_RihzKEqLrd7W0w",
    tone: "indigo",
  },
  {
    role_id: 5,
    formule: "Presence Ultim",
    label: "Presence Ultim",
    priceLabel: "30 € / an",
    amount: 30,
    product_id: "prod_Rii0cE4OKYDGV4",
    tone: "violet",
  },
];

export function normalizePlanName(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

export function findSubscriptionPlan(formule) {
  const normalizedFormule = normalizePlanName(formule);

  return (
    SUBSCRIPTION_PLANS.find(
      (plan) =>
        normalizePlanName(plan.formule) ===
        normalizedFormule,
    ) || null
  );
}